import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-pacijent-edit',
  templateUrl: './pacijent-edit.component.html',
  styleUrls: ['./pacijent-edit.component.css']
})
export class PacijentEditComponent implements OnInit {
  pacijentid = this.route.snapshot.params['id'];
  pacijent: any = {};
  pacijentRef;
  editPacijent: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    this.editPacijent = firebase
      .database()
      .ref('pacijenti/' + this.pacijentid + '/edit/');
    this.pacijentRef = firebase.database().ref('pacijenti/' + this.pacijentid);
  }
  updatePacijenta(form: NgForm) {
    const ime = form.value.ime;
    const prezime = form.value.prezime;
    const telefon = form.value.telefon;
    const datumR = form.value.datumrodjenja;
    const adresa = form.value.adresa;
    const email = form.value.email;

    firebase
      .database()
      .ref('pacijenti/' + this.pacijentid)
      .update({
        Ime: ime,
        Prezime: prezime,
        Telefon: telefon,
        DatumRodjenja: datumR,
        Adresa: adresa,
        Email: email
      })
      .then(() => this.location.back());
  }
  ngOnInit() {
    this.pacijentRef.once('value').then(snapshot => {
      this.pacijent = snapshot.val();
    });
  }
}
